// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3cbSs","content":"ManualTimeModal_content__2Bu6P"};